import { useState } from 'react';
import { Input } from '@/components/ui/input';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface AnularFacturaDialogProps {
  open: boolean;
  onOpenChange: () => void;
  onConfirm: (motivo: string) => void;
}

export function AnularFacturaDialog({ open, onOpenChange, onConfirm }: AnularFacturaDialogProps) {
  const [motivoAnulacion, setMotivoAnulacion] = useState('');

  const handleConfirm = () => {
    onConfirm(motivoAnulacion);
    setMotivoAnulacion('');
  };

  const handleCancel = () => {
    setMotivoAnulacion('');
    onOpenChange();
  };

  return (
    <AlertDialog open={open} onOpenChange={handleCancel}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Anular Factura</AlertDialogTitle>
          <AlertDialogDescription>
            La factura será marcada como anulada y se mantendrá en el sistema para cumplir con la normativa VeriFactu.
            {' '}Debes especificar el motivo de la anulación para que se envíe a la AEAT.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="py-4">
          <label htmlFor="motivoAnulacion" className="text-sm font-medium mb-2 block">
            Motivo de la anulación *
          </label>
          <Input
            id="motivoAnulacion"
            placeholder="Ej: Factura emitida por error, duplicada, etc."
            value={motivoAnulacion}
            onChange={(e) => setMotivoAnulacion(e.target.value)}
            className="w-full"
            autoFocus
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel}>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} className="bg-orange-600 hover:bg-orange-700">
            Anular Factura
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
